import React from 'react'
import { useParams } from 'react-router-dom';
import WidgetPreview from '../components/WidgetPreview';

export default function IframePage() {
    const { instanceId } = useParams<{ instanceId: string }>();
    return (
        <WidgetPreview
            instanceId={instanceId + ''}
        />
    )
}
